module.exports = __webpack_public_path__ + "static/InfectedPersonsPrefecture_18.dot-950e4cf766e4c761a043c74936e020bd.svg";